import { Utils } from "../../../common/views/Utils";
import { BankAccountModel } from "../../models/InvoiceModel";
import { QRCodeSVG } from "qrcode.react";

type InvoicePrintPaymentProps = {
    accounts: BankAccountModel[];
}

export default function InvoicePrintPaymentView({ accounts }: InvoicePrintPaymentProps) {
    return <div className="center">
        <div className="font-title">Payment Options</div>

        {accounts.map((account: BankAccountModel, index: number) => {
            return <div>
                {!Utils.isNullOrEmpty(account.qrCode) && <>
                    <div className="pt-10">
                        <QRCodeSVG value={account.qrCode ?? ""} size={120} level="H" />
                    </div>
                </>}
            </div>;
        })}
    </div>
}